export class StatusComprovante {
  id: number;
  status: string;
}
